import { DAY_HOURS } from '../../../constants/date'
import { CALENDAR_GRID_MINUTES_PER_ROW } from '../CalendarGrid.constants'

export const CALENDAR_GRID_WEEK_FIRST_HOUR = 7

export const CALENDAR_GRID_WEEK_HOUR_COUNT = 14

export const CALENDAR_GRID_WEEK_LAST_POSSIBLE_FIRST_HOUR =
  DAY_HOURS - CALENDAR_GRID_WEEK_HOUR_COUNT

export const CALENDAR_GRID_WEEK_WINDOW_MINUTES =
  CALENDAR_GRID_WEEK_HOUR_COUNT * CALENDAR_GRID_MINUTES_PER_ROW

export const CALENDAR_GRID_WEEK_SINGLE_DAY_COUNT = 1

export const CALENDAR_GRID_WEEK_FIRST_LANE = 0

export const CALENDAR_GRID_WEEK_SINGLE_LANE_COUNT = 1
